import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
// model
import { HttpHeaderService } from 'src/app/shared/service/http-header.service';
import { SearchService } from 'src/app/shared/service/search/search.service';
import { RequestManagerService } from 'src/app/shared/service/request-manager.service';

@Injectable({
  providedIn: 'root'
})
export class SearchWorkerService extends SearchService {
  // サービス毎に初期値を設定する
  initPage = { page: 1 };
  initPerPage = { perPage: 50 }; // TODO: 未使用（API側で200件ずつ取得するようになっているので使用できるようにすべき）
  selfServiceName = 'SearchWorkerService';

  constructor(
    header: HttpHeaderService, 
    http: HttpClient,
    requestManager: RequestManagerService,
    injector: Injector
  ) {
    super(header, http, requestManager, injector);
  }

  doSearch(id?: string, sortParams?: object, currentSearchCondition?: any): Observable<any> {
    return super.requestPost(
      'api/v1/workers',
      this.getSearchParameters(sortParams, currentSearchCondition)
    );
  }

  searchFocusMail(): Observable<any> {
    return super.requestGet(
      'api/v1/user_focus_mails?mail_side=worker',
      this.getSearchParameters()
    );
  }

  createOrDeleteFocusMail(focus_info): Observable<any> {
    return super.requestPost('api/v1/user_focus_mails', focus_info);
  }

  getSearchKeyword() {
    return super.requestGet(
      'api/v1/workers/index_search_keyword',
      this.getSearchParameters()
    );
  }

  getBestMails(): Observable<any> {
    return super.requestGet('api/v1/workers/best_mails');
  }
}
